import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RemovablePill from "../../../Components/RemovablePill/RemovablePill";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import ModalWorkItemLinks from "./ModalWorkItemLinks";
import { useState } from "react";

export default function WorkItemLinks({ links = [], className, style, onRemove, onAdd, onClick }) {
    const [showModalLinks, setShowModalLinks] = useState(false);
    return (
        <div className={`rem-pill-container ${className ?? ""}`} style={style}>
            <ModalWorkItemLinks onSelect={onAdd} show={showModalLinks} setShow={setShowModalLinks} />
            {links.map(
                (link, i) =>
                    <RemovablePill pill={{ ...link, text: link.PEntityType + ' ' + link.Code }} key={i} onRemove={onRemove} onClick={()=>onClick(link)}/>
            )}
            <label className="rem-pill" onClick={()=>setShowModalLinks(true)}>
                <FontAwesomeIcon icon={faPlus} /> جدید...
            </label>
        </div>
    )
}